import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, DestroyRef, Inject, OnInit, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { ToastAlertService } from '@core/services';
import { UserGroupService } from '../../../../services';
import { ButtonComponent } from '@shared/components/button/button.component';
import { InputComponent } from '@shared/components/input/input.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-worker-group-modal',
  templateUrl: './worker-group-modal.component.html',
  styles: [],
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDialogContent,
    InputComponent,
    MatDialogActions,
    ButtonComponent,
    MatDialogClose,
  ],
})
export class WorkerGroupModalComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<WorkerGroupModalComponent>);
  private alertService = inject(ToastAlertService);
  private workerGroupService = inject(UserGroupService);
  public operation = '';
  public workerGroupForm!: FormGroup;
  private destroyRef = inject(DestroyRef);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    console.log('datos existentes', data);
  }

  ngOnInit(): void {
    console.log(this.data.action);
    this.builderForm();
  }

  private builderForm() {
    if (this.data.action?.id) {
      this.operation = 'Modificar Grupo de usuarios';
      this.workerGroupForm = this.formBuilder.group({
        id: [this.data.action?.id],
        name: [
          this.data.action?.name,
          [Validators.required, Validators.maxLength(50)],
        ],
        description: [
          this.data.action?.description,
          [Validators.required, Validators.maxLength(256)],
        ],
      });
    } else {
      this.operation = 'Crear grupo de usuarios';
      this.workerGroupForm = this.formBuilder.group({
        id: ['0'],
        name: ['', [Validators.required, Validators.maxLength(50)]],
        description: ['', [Validators.required, Validators.maxLength(256)]],
      });
    }
  }

  get id_action() {
    return this.workerGroupForm.get('id');
  }

  submit() {
    if (this.id_action?.value == 0) {
      this.storeWorkerGroup();
    } else {
      this.updateWorkerGroup();
    }
  }

  private storeWorkerGroup() {
    this.workerGroupService
      .storeUserGroup(
        this.workerGroupForm.value,
        parseInt(this.data.businessId)
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.dialogRef.close(true);
            this.alertService.sucess('Grupo de usuarios creado');
          } else {
            // this.alertService.error(resp.detail);
          }
        },
      });
  }

  private updateWorkerGroup() {
    this.workerGroupService
      .updateUserGroup(
        this.workerGroupForm.value,
        this.id_action?.value,
        this.data.action.business_id
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.dialogRef.close(true);
            this.alertService.sucess('Grupo de usuarios modificado');
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  clearForm() {
    this.builderForm();
  }
}
